import centerCore from '../center'
import examCore from '../exam'
import portalCore from '../portal'
import playCore from '../play'
const center = centerCore()
const exam = examCore()
const play = playCore()
const portal = portalCore()
import VueRouter, { NavigationGuardNext, Route } from 'vue-router'

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [...center.router, ...portal.router, ...play.router, ...exam.router] as any
})
export default router
